export const PROVIDERS_REGISTRATION = {
    TEST: 'Test', 
};